// extracted by mini-css-extract-plugin
export default {"sidebar":"src-containers-layouts-styles-sidebar-r9kuh"};